<template>
	<button
		v-if="isLoggedIn"
		class="btn btn--extra-small btn--clean-link"
		type="button"
		:aria-label="i18n.storeConfiguration"
		ref="storeLink"
		data-module="modal"
		:data-config="getModalID()"
		v-on:click="openPopup"
	>
		<span class="btn__icon">
			<DownloadIcon class="icon-inline icon-inline--expanded svg-icon-download" aria-hidden="true" />
		</span>
		<span class="btn__text">{{ i18n.storeConfiguration }}</span>
	</button>
</template>

<script>
import DownloadIcon from "./icons/DownloadIcon";
import {MrModal} from "@level-level/recyclops";

export default {
	components: {
		DownloadIcon
	},
	data() {
		return {
			isLoggedIn: window.measurementSelectorVariables.loggedInUser,
		};
	},
	watch: {
		'window.measurementSelectorVariables.loggedInUser': function(newVal) {
			this.isLoggedIn = newVal;
		}
	},
	computed: {
		i18n: function() { return this.$i18n; },
	},
	methods: {
		openPopup: function() {
			const button = this.$refs.storeLink;

			new MrModal( button, {} );

			button.addEventListener( 'openMrModal', () => {} );
			button.addEventListener( 'closeMrModal', () => {} );
		},
		getModalID: function() {
			const modalID = window.measurementSelectorVariables.loggedInUser !== '' ? '{"modalID": "modal-store" }' : '{"modalID": "modal-favorite-login-cta" }';
			return modalID;
		}
	}
};
</script>
